import * as Sentry from '@sentry/react';
import {
  editCapitolKey,
  EditApiKeyProps,
} from '@/services/keys/edit-capitol-key';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';

export const useEditCapitolKey = (
  options?: Omit<
    UseMutationOptions<unknown, Error, EditApiKeyProps, unknown>,
    'mutationFn'
  >,
) => {
  return useMutation({
    ...options,
    mutationFn: editCapitolKey,
    onError: (error, variables, context, mutation) => {
      Sentry.captureException(error, {
        extra: { context: 'edit-capitol-key', keyId: variables.id },
      });
      options?.onError?.(error, variables, context, mutation);
    },
  });
};
